import {MassCertificationCustomer, MassCertificationCustomerApiResponse} from "@/core/interfaces/MassCertification";

const MassCertificationService = () => {
    const mapApiResponse = (data: MassCertificationCustomerApiResponse[]): MassCertificationCustomer[] => {
        return data.map(customer => ({
            id: customer.id,
            lastVisit: customer.last_visit,
            visits: customer.visits,
            messageDate: customer.last_conversation_message?.created_at,
            phone: customer.information.phone,
            birthDate: customer.information.birth_date,
            name: customer.information.name,
        }));
    };

    return {
        mapApiResponse
    };
};

export default MassCertificationService();
